module.exports = __webpack_public_path__ + "static/Merriweather-Light-9341552d8cbfd150ac426cbd065c51a0.ttf";